import { WidgetPreview } from "@/components/onboarding/widget-preview";

export function OnboardingWidgetSetup() {
  return (
    <div className="max-w-md mx-auto">
      <WidgetPreview />
    </div>
  );
}
